import {action, observable} from "mobx";

/**
 * Store to manage shared state.
 */

const wordGroups = 8;

const wordLists = [
    ["CHARACTER",
        "SHELTER",
        "SHUSH",
        "CHALICE"],
    ["CHAMPION",
        "PHRASE",
        "THANK",
        "THUNDER"],
    ["HELMET",
        "MAMMAL",
        "PLAZA",
        "VOCATION"],
    ["GIANT",
        "NIMROD",
        "ORACLE",
        "WIZARD"],
    ["CHILDISH",
        "PHOSPHATE",
        "SHIPSHAPE",
        "THESIS"],
    ["CHARITY",
        "CHORUS",
        "THERAPY",
        "THERMOS"],
    ["ARMORY",
        "DESIGNER",
        "FOLKLORE",
        "GUIDING"],
    ["ALPINE",
        "INHALE",
        "JIGSAW",
        "VENDOR"]];

class WordColorPickerStore {

    backgroundGrey = '#dddddd';
    letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    @observable letterColours = {};
    @observable wordList = ['MAGIC','CHECK','BASELINE'];
    @observable wordSettings = {};

    @observable formControls = {
        have_syn: -1,
        type_of_syn_colours_for_letters: 0,
        type_of_syn_colours_for_numbers: 0,
        type_of_syn_colours_for_words: 0,
        type_of_syn_colours_for_other_sequences: 0,
        type_of_syn_personalities_for_letters: 0,
        type_of_syn_personalities_for_numbers: 0,
        type_of_syn_spatial_arrangement_for_letters: 0,
        type_of_syn_spatial_arrangement_for_numbers: 0,
        type_of_syn_spatial_arrangement_for_other_sequences: 0,
        type_of_syn_other: 0,
        type_of_syn_comments: "",
        colours_for_words: -1,
        colours_for_words_comments: "",
        syn_ex: "",
        proj_assoc_comments: "",
        positives: "",
        bugs_comments: "",
        confused_comments: "",
        missing_comments: "",
        next_comments: "",
        general_comments: ""
    };

    @observable lastGroupChosen = -1;

    @action setFormControl(name, value) {

        const newFormControls = { ...this.formControls, [name]: value };
        this.formControls = newFormControls;
    }

    setUnsetLetters() {
        for (var i = 0; i < this.letters.length; i += 1) {
            if (this.letterColours[this.letters[i]] === undefined) {
                this.letterColours[this.letters[i]] = '';
            }
        }
    }

    allLettersSet() {
        let allSet = true;
        for (var i = 0; i < this.letters.length; i += 1) {
            allSet = allSet && this.letterColours[this.letters[i]] !== undefined;
        }
        return allSet;
    }

    @action setLetterColour = (letter, colour)  => {
        this.letterColours[letter] = colour;
    }

    @action setWordSettings = (word, settings) => {
        this.wordSettings[word].settings = settings;
    };

    @action setWordLocked = (word, locked) => {
        this.wordSettings[word].locked = locked;
    };

    @action setWordList = (wordList) => {
        this.wordList = wordList;
    }

    allWordsAdded() {
        for(var i = 0 ; i < wordGroups; i += 1) {
            for (var j = 0; j < wordLists[i].length; j += 1) {
                if (this.wordList.indexOf(wordLists[i][j]) == -1) {
                    return false;
                }
            }
        }

        return true;
    }

    @action addNextWord = () => {


        for(var i = 0 ; i < wordGroups; i += 1) {

            var group = (this.lastGroupChosen + i + 1) % wordGroups;
            var wordAdded = false;

            var wordInListOffset = Math.floor(Math.random() * wordLists[group].length);

            for (var j = 0; j < wordLists[group].length; j += 1) {

                var wordInList = j + wordInListOffset % (wordLists[group].length)

                if (this.wordList.indexOf(wordLists[group][wordInList]) == -1) {
                    this.addWord(wordLists[group][wordInList]);
                    wordAdded = true;
                    break;
                }
            }

            if (wordAdded) {
                this.lastGroupChosen = group;
                break;
            }
        }
    }

    @action addWord = (word) => {
        if (typeof word === 'string' && word.length > 1) {
            this.wordList.push(this.cleanWord(word));
        }
    }

    @action removeWord = (word) => {
        // First check that word is deletable
        if (this.wordList.indexOf(word) > 2) {
            this.wordList = this.wordList.filter(w => w !== word);
            delete this.wordSettings[word];
        }

    }

    cleanWord(word) {
        return word.replace(/[^A-Za-z]/g, '').toUpperCase();
    }

    getLetterSettings(word) {
        this.assertWordSettings(word);
        return this.wordSettings[word].settings;
    }

    getWordLockedStatus(word) {
        this.assertWordSettings(word);
        return this.wordSettings[word].locked;
    }

    @action resetWordSettings(word) {
        delete this.wordSettings[word];
        this.assertWordSettings(word);
    }

    assertWordSettings(word) {
        if (!this.wordSettings[word]) {
            this.wordSettings[word] = { settings: this.createInitialWordState(word), locked: false };
        }
    }

    firstWordsLocked() {
        for(var i = 0; i < 3 ; i += 1) {
            if (!this.getWordLockedStatus(this.wordList[i])) {
                return false;
            }
        }
        return true;
    }

    allWordsLocked() {
        for(var i = 0; i < this.wordList.length ; i += 1) {
            if (!this.getWordLockedStatus(this.wordList[i])) {
                return false;
            }
        }
        return true;
    }

    createInitialWordState(word) {

        const letters = [];
        for (var i = 0; i < word.length; i += 1) {
            
            letters.push({
                letter: word[i],
                rgb: {r: 0,g: 0,b: 0},
                hex: null,
                leftStrength: 0.25,
                rightStrength: 0.25
            });
        }
        return letters;
    }

};


const wcpStore = new WordColorPickerStore();

export default wcpStore;
